import { render, staticRenderFns } from "./PublishModal.vue?vue&type=template&id=a9a4f920&"
import script from "./PublishModal.vue?vue&type=script&lang=js&"
export * from "./PublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports